import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from '../../_services/index';
import { PasswordService } from '../../_services/password.service';

@Component({
    moduleId: module.id,
     selector: 'app-login',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})

export class PasswordComponent {
    model: any = {};
    loading = false;
    error = '';

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private PasswordService: PasswordService,
        private route: ActivatedRoute) { }

    setPassword() {
        this.loading = true;
        this.model['token'] = this.route.snapshot.paramMap.get('token');
        this.PasswordService.setPassword(this.model)
            .subscribe(data => {
                let res = data.json();
                if (res['status'] == 1) {
                    
                    if (res['role'] == 1) {
                        this.authenticationService.login(res['email'], this.model.newPassword)
                            .subscribe(result => {
                                if (result === true) {
                                    this.router.navigateByUrl('/admin/projects/list');
                                } else {
                                    this.router.navigateByUrl('/admin/login');
                                }
                            });
                    } else if (res['role'] == 2) {
                        this.authenticationService.userLogin(res['email'], this.model.newPassword)
                            .subscribe(result => {
                                if (result === true) {
                                    this.router.navigateByUrl('/survey');
                                } else {
                                    this.router.navigateByUrl('/login');
                                }
                            });
                    }
                } else {
                    this.error = 'You don\'t have permission to set password for this user';
                    this.loading = false;
                }
            });
    }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/views/password/password.component.ts